/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgPageViewModelGen,
  ThgThgVehicleMeControllerGetAllPaginatedParamsGen,
  ThgThgVehicleViewModelGen,
  ThgUpdateMyVehicleDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class MyVehicles<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags My Vehicles
   * @name ThgVehicleMeControllerGetAllPaginated
   * @summary Get my thg vehicles
   * @request GET:/vehicle/me
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgThgVehicleViewModelGen)[] })`
   */
  thgVehicleMeControllerGetAllPaginated = (
    query: ThgThgVehicleMeControllerGetAllPaginatedParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgThgVehicleViewModelGen[] }, any>({
      path: `/vehicle/me`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags My Vehicles
   * @name ThgVehicleMeControllerGetOne
   * @summary Gets a particular of my thg vehicle
   * @request GET:/vehicle/me/{id}
   * @secure
   * @response `200` `ThgThgVehicleViewModelGen` THG Vehicle that will be returned
   */
  thgVehicleMeControllerGetOne = (id: string, params: RequestParams = {}) =>
    this.http.request<ThgThgVehicleViewModelGen, any>({
      path: `/vehicle/me/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags My Vehicles
   * @name ThgVehicleMeControllerUpdateOne
   * @summary Updates one of my vehicles
   * @request PATCH:/vehicle/me/{id}
   * @secure
   * @response `200` `ThgThgVehicleViewModelGen` THG Vehicle that will be returned
   */
  thgVehicleMeControllerUpdateOne = (id: string, data: ThgUpdateMyVehicleDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgThgVehicleViewModelGen, any>({
      path: `/vehicle/me/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
